import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import {
  getBaseExportSchema,
  MessageFormatter,
} from '@app/modules/social-export/components/validation/base-export-schema';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { FormSection } from '@app/modules/social-export/screens/manage/platforms/FormSection';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid, Stack } from '@mui/material';
import { useMemo } from 'react';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';

interface DemoPublishValues {
  title: string;
  description: string;
  publishAt: string | null;
}

type DemoPublishFormProps = BaseExportFormProps<any, socialExport.DemoSettingsDto>;

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };

function getDemoPublishValidationSchema(t: MessageFormatter) {
  return getBaseExportSchema(t).extend({
    title: z.string().trim().min(1, t(requiredMsg)),
    description: z.string().trim().min(1, t(requiredMsg)),
  });
}

export function DemoPublishForm({
  fragment,
  onUpload,
  videoUrl,
  defaultSettings,
  actions,
}: DemoPublishFormProps) {
  const { $t } = useIntl();
  const schema = useMemo(() => getDemoPublishValidationSchema((msg) => $t(msg)), [$t]);
  const initialValues: DemoPublishValues = {
    title: fragment.title ?? '',
    description: fragment.description ?? '',
    publishAt: null,
  };

  return (
    <FormContainer
      values={initialValues}
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(formData);
      }}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.demoData',
          defaultMessage: 'Datos de demo',
        })}
      >
        <Stack spacing={3}>
          <TextFieldElement
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
          <TextFieldElement
            name="description"
            label={$t({
              id: 'socialExport.form.description',
              defaultMessage: 'Descripción',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </FormSection>
      <FormSection
        title={$t({
          id: 'socialExport.form.schedule',
          defaultMessage: 'Programación',
        })}
      >
        <Grid container>
          <Grid item md={12}>
            <SocialPublishAtField />
          </Grid>
        </Grid>
      </FormSection>
      {actions}
    </FormContainer>
  );
}
